/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const bottomWallItemWithCustomCountertopComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'countertop', true).withAlias('BottomWallItemWithCustomCountertop').withFilter((s)=>s.$countertopFilter).attach(memoEval((self)=>[
            self.$countertopObjectName
        ], ($countertopObjectName)=>({
            fileUrl: '/models/jms.glb',
            objectName: $countertopObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'countertop', true).withAlias('BottomWallItemWithCustomCountertop').attach(memoEval((self)=>[
            self.$countertopOffsetX,
            self.$countertopWidth,
            self.$countertopWidthScaleZero,
            self.$countertopWidthScaleOne,
            self.$countertopDepth,
            self.$countertopDepthScaleZero,
            self.$countertopDepthScaleOne,
            self.$countertopDepthInner,
            self.$countertopDepthInnerScaleZero,
            self.$countertopDepthInnerScaleOne,
            self.$countertopSideInnerWidth,
            self.$countertopSideWidthScaleZero,
            self.$countertopSideWidthScaleOne,
            self.$countertopLeftSideOuterWidth,
            self.$countertopRightSideOuterWidth
        ], ($countertopOffsetX, $countertopWidth, $countertopWidthScaleZero, $countertopWidthScaleOne, $countertopDepth, $countertopDepthScaleZero, $countertopDepthScaleOne, $countertopDepthInner, $countertopDepthInnerScaleZero, $countertopDepthInnerScaleOne, $countertopSideInnerWidth, $countertopSideWidthScaleZero, $countertopSideWidthScaleOne, $countertopLeftSideOuterWidth, $countertopRightSideOuterWidth)=>({
            offsetX: $countertopOffsetX,
            morphTargetInfluences: {
                Width: {
                    value: $countertopWidth,
                    scaleZero: $countertopWidthScaleZero,
                    scaleOne: $countertopWidthScaleOne
                },
                Depth: {
                    value: $countertopDepth,
                    scaleZero: $countertopDepthScaleZero,
                    scaleOne: $countertopDepthScaleOne
                },
                DepthInner: {
                    value: $countertopDepthInner,
                    scaleZero: $countertopDepthInnerScaleZero,
                    scaleOne: $countertopDepthInnerScaleOne
                },
                DepthOuter: {
                    value: $countertopDepth,
                    scaleZero: $countertopDepthScaleZero,
                    scaleOne: $countertopDepthScaleOne
                },
                LeftSideInner: {
                    value: $countertopSideInnerWidth,
                    scaleZero: $countertopSideWidthScaleZero,
                    scaleOne: $countertopSideWidthScaleOne
                },
                LeftSideOuter: {
                    value: $countertopLeftSideOuterWidth,
                    scaleZero: $countertopSideWidthScaleZero,
                    scaleOne: $countertopSideWidthScaleOne
                },
                RightSideInner: {
                    value: $countertopSideInnerWidth,
                    scaleZero: $countertopSideWidthScaleZero,
                    scaleOne: $countertopSideWidthScaleOne
                },
                RightSideOuter: {
                    value: $countertopRightSideOuterWidth,
                    scaleZero: $countertopSideWidthScaleZero,
                    scaleOne: $countertopSideWidthScaleOne
                },
                LeftSide: {
                    value: $countertopLeftSideOuterWidth,
                    scaleZero: $countertopSideWidthScaleZero,
                    scaleOne: $countertopSideWidthScaleOne
                },
                RightSide: {
                    value: $countertopRightSideOuterWidth,
                    scaleZero: $countertopSideWidthScaleZero,
                    scaleOne: $countertopSideWidthScaleOne
                }
            }
        })))
];

//# sourceMappingURL=bottom-wall-item-with-custom-countertop.js.map